import { render, staticRenderFns } from "./FilterPill.vue?vue&type=template&id=741f5b16&"
import script from "./FilterPill.vue?vue&type=script&lang=js&"
export * from "./FilterPill.vue?vue&type=script&lang=js&"
import style0 from "./FilterPill.vue?vue&type=style&index=0&id=741f5b16&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports